import React from 'react';
import { HevoCustomer, HevoTestimonial } from '../../../core/interfaces/customers';
import styles from './TestimonialSection.module.scss';

export interface FeaturedCustomers {
  customers: HevoCustomer[];
  testimonials: HevoTestimonial[];
}

export interface TestimonialSectionProps {
  className?: string;
  featuredCustomers: FeaturedCustomers;
}

export function TestimonialSection({ className = '', featuredCustomers }: TestimonialSectionProps) {
  return (
    <div className={`${styles.testimonialSection} ${className}`}>
      <div className={styles.testimonialContainer}>
        <div className={styles.testimonialContent}>
          <h1 className={'text-headline-1'}>
          Move your data reliably, with full visibility and complete control.

          </h1>
          <div>
            <h5 className={'text-subheading-1 pt-8 pb-6'}>Data driven companies trust Hevo
            </h5>
            <div className={styles.customerLogoWrapper}>
              {featuredCustomers.customers.map((customer) => (
                <img className={styles.customerLogo} key={customer.name} src={customer.logoWhite} alt={customer.name} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
